export default __webpack_public_path__ + "static/media/logo_mini.690d4335.png";